import React from 'react';

const processStepsWithImages = [
  {
    number: "01",
    title: "Align",
    description: "We discuss your book, identify key visual moments, and define which materials fit your goals and timeline.",
    image: "https://static.prod-images.emergentagent.com/jobs/317f23d0-46b8-4950-84d1-7510999107bb/images/cc798e1f95e192a067f9c2895a4ae848c358a3041452fd37149be8d2afb22f81.png"
  },
  {
    number: "02",
    title: "Create",
    description: "Production begins on the agreed materials: trailers, design references, or scene content, all tailored to your story.",
    image: "https://static.prod-images.emergentagent.com/jobs/317f23d0-46b8-4950-84d1-7510999107bb/images/e36763d8d1cb285c0b93e02a0c6ed3f84f539ec21d97553b934b54fdbcc8a40b.png"
  },
  {
    number: "03",
    title: "Use",
    description: "You receive finished assets ready to share across platforms, campaigns, and promotional channels as needed.",
    image: "https://static.prod-images.emergentagent.com/jobs/317f23d0-46b8-4950-84d1-7510999107bb/images/470ae4321fa2d4a652eb455ff2a64abfded68ac323e0cdb38d0ba66c37cd932f.png"
  }
];

const ProcessSection = () => {
  return (
    <section className="py-20 px-4 bg-[#061018] relative overflow-hidden">
      {/* Abstract background elements */}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="abstract-blob animate-float" style={{ 
          top: '20%', 
          left: '10%', 
          width: '450px', 
          height: '450px', 
          background: 'radial-gradient(circle, rgba(255, 101, 0, 0.25), transparent 70%)',
          filter: 'blur(75px)'
        }}></div>
        <div className="abstract-blob animate-float-delayed" style={{ 
          bottom: '15%', 
          right: '10%', 
          width: '400px', 
          height: '400px', 
          background: 'radial-gradient(circle, rgba(255, 140, 50, 0.2), transparent 70%)',
          filter: 'blur(80px)'
        }}></div>
      </div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-6xl font-bold text-white mb-4 text-center">
          How Collaboration <span className="text-[#FF6500]">Works</span>
        </h2>
        <p className="text-xl text-[#aaa] text-center mb-16 max-w-3xl mx-auto">
          A clear, modular way to turn your book into augmented cinematic proof.
        </p>
        
        <div className="grid md:grid-cols-3 gap-8">
          {processStepsWithImages.map((step, index) => {
            return (
              <div 
                key={index}
                className="relative bg-[#0a1525] rounded-lg border border-[#152840] hover:border-[#FF6500]/30 transition-all duration-300 overflow-hidden"
              >
                {/* Image at top */}
                <div className="aspect-video w-full overflow-hidden">
                  <img 
                    src={step.image} 
                    alt={step.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                {/* Content */}
                <div className="p-8">
                  <div className="text-6xl font-bold text-[#FF6500]/20 mb-4">{step.number}</div>
                  <h3 className="text-3xl font-semibold text-white mb-4">{step.title}</h3>
                  <p className="text-base text-[#aaa] leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
